export default __webpack_public_path__ + "static/media/bigs.0b228300.svg";